import React from 'react';
import "../../styles/unknown/error_occured.css";
import { useSearchContext } from "../chats/searchContext";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { firebaseAuth } from "../firebase/firebase_configuration";
import errorImage from "../../images/unknown/error_image.png";

const ErrorOccured = () => {
    const {setUnknownTab} = useSearchContext();
    const [getUserId, setUserId] = useState("");

    useEffect (() => {
        const isLoggedIn = onAuthStateChanged(firebaseAuth, (user) => {
          if (user) {
            setUserId(user.uid);
          }
        });
    
        return () => isLoggedIn();
    }, []);

    return(
        <div className="error_occured_screen">
            <img alt='Error Wallpaper' className="error_occured_screen_image" src={errorImage} />
            <Link onClick={() => {setUnknownTab(""); window.location.reload();}} to={getUserId === "" || getUserId == null ? "/login" : "/main_back/home"} className="page_not_found_screen_link"><p className="page_not_found_screen_link_text">{getUserId === "" || getUserId == null ? "Go to the Login Page" : "Go to the Home Page"}</p></Link>
        </div>
    );
};

export default ErrorOccured;